import React from "react";

import Card from "../Card";

import { personalTitle, personalData } from "../../data/personalData";

import { sortByImportance } from "../../utils";

const Personal = ({ activeSection }) => {
  const personals = sortByImportance(personalData);

  return (
    <section id="personal">
      <h3 className={activeSection === "personal" ? "active" : ""}>
        {personalTitle}
      </h3>
      <ul>
        {personals.map((el) => (
          <Card
            key={el.key}
            date={el.date}
            title={el.title}
            establishment={el.establishment}
            details={el.details}
            info={el.info}
            skills={el.skills}
            image={el.image}
            links={el.links}
          />
        ))}
      </ul>
    </section>
  );
};

export default Personal;
